import { claimReasonsError, labelTypeError, packageDelayReasonRequiredError, packageProblemReasonRequiredError, statusError, } from '../../constants/errors';
import { PackageStatus } from '../../graphql/generated/api';
var validation = function (values) {
    var errors = {};
    if (!values.labelType) {
        errors.labelType = labelTypeError;
    }
    if (!values.status) {
        errors.status = statusError;
    }
    if (values.status === PackageStatus.DELAYED && !values.packageDelayReason) {
        errors.packageDelayReason = packageDelayReasonRequiredError;
    }
    if (values.status === PackageStatus.PROBLEM && !values.packageProblemReason) {
        errors.packageProblemReason = packageProblemReasonRequiredError;
    }
    if (values.claim && !values.claimReason) {
        errors.claimReason = claimReasonsError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=package.js.map